import { useNavigate } from 'react-router-dom';
import { DC } from '../../../../../shared/components/dashboard/DASHBOARD_COLORS';

export function DashboardsPanel() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 800 }}>
      <div
        onClick={() => navigate('/process')}
        style={{
          backgroundColor: '#fff',
          border: `1px solid ${DC.grisMed}`,
          borderLeft: `4px solid ${DC.azul1}`,
          borderRadius: 6,
          padding: '20px 24px',
          cursor: 'pointer',
          transition: 'box-shadow 0.15s',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 8,
            backgroundColor: DC.azulSuave,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            flexShrink: 0,
          }}
        >
          &#128202;
        </div>
        <div>
          <div
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              fontSize: 16,
              color: DC.azul1,
              marginBottom: 4,
            }}
          >
            CMI - Procesos
          </div>
          <div style={{ fontSize: 13, color: DC.grisOsc }}>
            Caracterizacion y Digitalizacion de Procesos
          </div>
        </div>
        <div style={{ marginLeft: 'auto', color: DC.grisMed, fontSize: 20 }}>&rarr;</div>
      </div>
    </div>
  );
}
